import { RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE } from '../../constants/password'
import Api from '../../services/api.js'

export function resetPasswordRequest() {
  return {
    type: RESET_PASSWORD_REQUEST
  }
}

export function resetPasswordSuccess() {
  return {
    type: RESET_PASSWORD_SUCCESS
  }
}

export function resetPasswordFailure(exception) {
  return {
    type: RESET_PASSWORD_FAILURE
  }
}

export function resetPassword(email) {
  return dispatch => {
    dispatch(resetPasswordRequest())
    const api = new Api();
    return api.post("/api/v1/forgot_password", {email: email})
    .then(response => {
      if (response.status === 201){
        dispatch(resetPasswordSuccess())
      }
    })
    .catch(exception => dispatch(resetPasswordFailure(exception)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/password/reset.js